// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/cookie-policy/cookie-policy.component.scss
// module id = 237
// module chunks = 0